import { twMerge } from 'tailwind-merge'
import { ISection } from '../../../models/ISection'
import Post from '../../components/Post'
import Swiper from './Swiper'
import Link from 'next/link';
import SectionTitle from '../../components/SectionTitle';

export default function SectionEight(data: ISection) {
  if (!data?.posts?.length) return null;
  return (
      <section key={data.internalName} className='section-full bg-gray-0 py-[48px] dark:bg-quinary'>
        {data.showTitle && data.title ? <SectionTitle title={data.title} href={`/${data.targetSlug}`} classNames={{wrapper: 'bg-transparent', text: 'dark:text-white'}} target='_self'/> : null}
       <div className='hidden desktop:grid grid-cols-5 gap-[24px]'>
        {data.posts.map((p,i) => {
          return (
          <Post
          badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
          newsType={p.newsType} 
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={p.type} 
            title={p.title}
            image={{src: p.image, fill: true, sizes: '100vw', className: 'rounded-[12px] aspect-[3/4]', alt: p.imageAlt || '', ...(data.eager ? {priority: true, loading: 'eager'} : {})}} 
            category={p.category} 
            uniqueCode={p.uniqueCode}
            hide={{category: true}}
            classNames={{contentContainer: 'py-[16px] flex-1 px-[12px]', image: twMerge('mb-0'), title: 'h6 line-clamp-2', wrapper: 'flex-1 rounded-[12px] h-full'}}
            thumbnail={p.thumbnail}
          />
        )})}
       </div>

        <div className='grid grid-cols-1 desktop:hidden gap-[24px]'>
          <Swiper 
         id={String(data.template.id + data.id)}
          key={String(data.template.id + data.id)}
          slides={data.posts.map(p => (
            <Post 
            isLarge
            badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
            newsType={p.newsType}
              key={p.uniqueCode + '2'}
              targetSlug={data.targetSlug} 
              automated={data.automated} 
              targetType={data.targetType} 
              type={p.type} 
              title={p.title}
              image={{src: p.image, fill: true, sizes: '100vw', className: 'rounded-[12px]', alt: p.imageAlt || '', ...(data.eager ? {priority: true, loading: 'eager'} : {})}} 
              category={p.category} 
              uniqueCode={p.uniqueCode}
              classNames={{contentContainer: 'py-[16px] px-[12px]', image: twMerge('mb-0 aspect-[3/4]'), wrapper: 'rounded-[12px]', title: 'h6 line-clamp-2'}}
              hide={{category: true}}
              thumbnail={p.thumbnail}
            />
          ))}
          />
       </div>
          <Link href={`/${data.targetSlug}`} className={twMerge('rounded-[6px] grid place-items-center w-fit px-[12px] h-[36px] cursor-pointer transition-all duration-300 hover:scale-[103%] self-end ml-[24px] desktop:ml-0 bg-gray-100 dark:bg-quaternary')}>
      <span className='text-dark dark:text-white h6'>المزيد</span>
    </Link>
      </section>
  )
}